import DropdownMulti from './components/dropdown-multi'
import DropdownSingle from './components/dropdown-single'

const DropdownComponent = ({ isMulti, ...props }) => {
  if (isMulti) {
    return <DropdownMulti {...props} />
  }

  return <DropdownSingle {...props} />
}

export default DropdownComponent
